import "./Projects.css";
import { projects, tags } from "./constants";

import { useState } from "react";

function Projects() {
	const [searchInput, setSearchInput] = useState("");
	const [selectedTag, setSelectedTag] = useState("");

	function handleSearchInput(event) {
		setSearchInput(event.target.value);
		setSelectedTag("");
	}

	function handleTagClick(tag) {
		setSelectedTag(tag === selectedTag ? "" : tag);
		setSearchInput("");
	}

	return (
		<section className="mt-sm-5 pt-sm-5 mt-5 pt-5">
			<h1 className="mt-sm-5 pt-sm-5">
				Projetos{" "}
				<span className=" fw-bold color-accents-blue">realizados!</span>
			</h1>
			<h2 className="fs-5">
				Confira abaixo alguns dos projetos que já{" "}
				<span className="color-300">desenvolvi</span> e que estão disponíveis
				para visualização.
			</h2>
			<div className="form-group has-search mt-5s">
				<input
					onChange={handleSearchInput}
					type="text"
					className="w-25 bg-transparent color-300 no-border text-white"
					placeholder="Pesquisar"
				/>
			</div>
			{searchInput}
			<div className="mt-5">
				{tags.map((tag) => (
					<button
						className={`btn badge mx-1 color-800 fw-bolder ${
							tag === selectedTag
								? "bg-accent-yellow"
								: "bg-accent-blue bg-hover-accent-blue"
						}`}
						key={tag}
						onClick={() => handleTagClick(tag)}
					>
						{tag}
					</button>
				))}
			</div>
			<div
				className="row py-5 px-sm-5 justify-content-center align-items-stretch "
				id="projectsList"
			>
				{(() => {
					const filteredProjects = projects.filter((project) => {
						const matchesSearch = searchInput
							? project.tags.some((tag) =>
									tag.toLowerCase().includes(searchInput.toLowerCase())
							  )
							: true;

						const matchesTag = selectedTag
							? project.tags.includes(selectedTag)
							: true;

						return matchesSearch && matchesTag;
					});

					if (filteredProjects.length === 0) {
						return (
							<div className="text-center py-5">
								<h3 className="color-300">Nenhum projeto encontrado</h3>
								<p className="fs-5">
									Tente buscar por outras palavras-chave ou tags.
								</p>
							</div>
						);
					}

					return filteredProjects.map((project) => (
						<div
							className="col-12 col-sm-6 col-lg-4 py-3 project"
							key={project.title}
						>
							<div className="box d-flex flex-column bg-700 scale h-100 ">
								<div className="box-image ">
									<a href={project.url} target="_blank" rel="noreferrer">
										<img
											src={project.image || "https://placehold.co/1920x1080"}
											className="img-fluid p-3 ratio ratio-16x9"
											alt="imagem do projeto"
										/>
									</a>
								</div>
								<div className="box-content p-3 flex-grow-1	">
									<h3 className="fs-4 color-accents-yellow">
										<a
											href={project.url}
											target="_blank"
											className="text-decoration-none"
											rel="noreferrer"
										>
											{project.title}
										</a>
									</h3>
									<p className="fs-5">{project.description}</p>
								</div>
								<div className="box-footer text-end">
									<div className="tags text-start px-3">
										{project.tags.map((tag) => (
											<span
												className="badge bg-accent-blue bg-hover-accent-blue mx-1 color-800 fw-bolder"
												key={tag}
											>
												{tag}
											</span>
										))}
									</div>
									<a
										className="btn color-accents-blue"
										target="_blank"
										href={project.repo ? project.repo : project.url}
										rel="noreferrer noopener"
									>
										Ver Projeto
									</a>
								</div>
							</div>
						</div>
					));
				})()}
			</div>
		</section>
	);
}

export default Projects;
